var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"report-horizontal-bar mb-mid"},[_c('h2',{staticClass:"mb-min"},[_vm._v("\n    "+_vm._s(_vm.item.name == "All" ? "Hela gruppen" : _vm.item.name)+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"mb-min"},[_c('report-table',{attrs:{"table-header":_vm.tableHeader,"data":_vm.getDataForTable(_vm.item.data)}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f9d21eb6","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/reports/tables/ReferenceTable.vue
// module id = D3BV
// module chunks = 0 1